import { render, staticRenderFns } from "./SveiConfigurazionePuntiIncontroPageList.vue?vue&type=template&id=f804cf10"
import script from "./SveiConfigurazionePuntiIncontroPageList.vue?vue&type=script&lang=js"
export * from "./SveiConfigurazionePuntiIncontroPageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports